
/**
 * Determines if an email is Owal Staff or not.
 *
 * @export
 * @param {String} email An email address to check.
 * @return {Boolean} `true` if the email is allowed superuser permissions. Otherwise, `false`.
 */
export function isOwalStaff (email) {
  if (email.endsWith('@owal.io')) {
    return true
  }
  return false
}
